import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    sendPasswordResetEmail,
    sendEmailVerification,
    onAuthStateChanged
} from "firebase/auth";
import { auth } from "./firebase";

export const authService = {
    // Sign up a new user
    signUp: async (email, password) => {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        return userCredential.user;
    },

    // Sign in an existing user
    signIn: async (email, password) => {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        return userCredential.user;
    },

    // Sign out the current user
    logout: async () => {
        await signOut(auth);
    },

    // Send password reset email
    resetPassword: async (email) => {
        await sendPasswordResetEmail(auth, email);
    },

    // Send email verification
    verifyEmail: async (user) => {
        await sendEmailVerification(user);
    },

    // Observe auth state changes
    onAuthStateChanged: (callback) => {
        return onAuthStateChanged(auth, callback);
    }
};